import React, { useEffect, useState, useRef } from "react";
import { Link, NavLink, useHistory, useLocation } from "react-router-dom";
import Swal from "sweetalert2";
import socket from "../Components/socket";
import "../css/landing.css";
import Rightcontainer from "../Components/Rightcontainer";
import Downloadbutton from "../Components/Downloadbutton";
import io from "../Components/socket";
import Socket from "./../Components/socket";
import Header from "../Components/Header";
import { Token } from "@mui/icons-material";

export default function Landing({ userAllData }) {
  // const [userAllData, setUserAllData] = useState()

  const addsetting = localStorage.getItem("sitSetting");
  const addCaseSetting = JSON.parse(addsetting);
  // console.log(addCaseSetting);

  // const role = async () => {
  //   const access_token = localStorage.getItem('token')
  //   io.emit('getprofile', access_token)
  //   io.on('setProfile', data => {
  //     // setUserAllData(data)
  //   })
  // }

  const [open, setOpen] = useState(false);

  useEffect(() => {
    io.on("setProfile", (data) => {
      setOpen(data.superUser);
      localStorage.setItem("udata", JSON.stringify(data));
    });
  }, [Socket]);

  useEffect(() => {
    const data = localStorage.getItem("udata");
    const userData = JSON.parse(data);
    setOpen(userData?.superUser);
  }, []);

  return (
    <>
      <div className="leftContainer py-5 comman-color">
        <div className="mt-3  Orher_page_main_section">
          <div className="main-area">
            <div className="gameCard">
              <div className="alrt_msg_div">
                {open == true ? (
                  <h5 className="">
                    {JSON.parse(localStorage.getItem("sitSetting")) ==
                      "undefined"
                      ? ""
                      : JSON.parse(localStorage.getItem("sitSetting"))
                        ?.site_message}
                  </h5>
                ) : (
                  ""
                )}

                {open == false ? (
                  <h5 className="">
                    भारत सरकार के निर्देशानुसार ऑनलाइन मनी गेमिंग बंद
                    कर दी गई है |
                  </h5>
                ) : (
                  ""
                )}
              </div>
            </div>

            {JSON.parse(localStorage.getItem("udata"))?.verified ===
              "unverified" ? (
              <div className="collapseCard-container">
                <div className="kyc_alert_wrapper">
                  <Link to="/Profile" className="kyc_alert_link">
                    <div className="kyc_alert_banner">
                      <div className="kyc_alert_content">
                        <div className="alert_icon_pulse">
                          <img
                            height="30px"
                            width="30px"
                            src="/images/icons/face-detection.png"
                            alt=""
                          />
                        </div>
                        <div className="alert_text_area">
                          <span className="alert_title">Action Required</span>
                          <p className="alert_desc">
                            Complete Your KYC Verification
                          </p>
                        </div>
                      </div>

                      {/* Decorative background glow */}
                      <div className="banner_glow_effect"></div>
                    </div>
                  </Link>
                </div>
              </div>
            ) : (
              ""
            )}

            <section className="games-section">
              <h2 class="title mt-3  text-uppercase">
                <span>Our Tournaments</span>
              </h2>
              <div className="d-flex align-items-center justify-content-between mt-3 mb-0"></div>
              <div className="games-section-headline mt-0 mb-1">
                <div className="games-window ">
                  <>
                    {/* =================Ludo Classic================ */}

                    {addCaseSetting?.isLudokingClassic && open == true ? (
                      <Link
                        className="gameCard-container"
                        to={`/Homepage/ludoClassicManual`}
                      >
                        <span className="ribbon">◉ LIVE</span>
                        <picture className="gameCard-image">
                          <img
                            src={
                              process.env.PUBLIC_URL +
                              "./mainimage/ludo-classic.jpg"
                            }
                            alt=""
                          />
                        </picture>
                      </Link>
                    ) : (
                      ""
                    )}

                    {/* =================Ludo skill Classic================ */}
                    {addCaseSetting?.isSkillLudo || open != true ? (
                      <Link
                        className="gameCard-container"
                        to={`/Homepage/skillludo`}
                      >
                        <span className="d-none blink text-danger d-block text-right game_status_live">
                          ◉ LIVE
                        </span>
                        <picture className="gameCard-image">
                          <img
                            src={
                              process.env.PUBLIC_URL +
                              "./mainimage/ludo-classic.jpg"
                            }
                            alt=""
                          />
                        </picture>
                      </Link>
                    ) : (
                      ""
                    )}

                    {/* speed ludo */}
                    {addCaseSetting?.isSkillLudoSpeed || open != true ? (
                      <Link
                        className="gameCard-container"
                        to={`/Homepage/speedludo`}
                      >
                        <span className="d-none blink text-danger d-block text-right game_status_live">
                          ◉ LIVE
                        </span>
                        <picture className="gameCard-image">
                          <img
                            src={
                              process.env.PUBLIC_URL +
                              "./mainimage/speedludo.jpg"
                            }
                            alt=""
                          />
                        </picture>
                      </Link>
                    ) : (
                      ""
                    )}

                    {open == true ? (
                      <a
                        className="gameCard-container"
                        href={
                          JSON.parse(localStorage.getItem("sitSetting")) ==
                            "undefined"
                            ? ""
                            : JSON.parse(localStorage.getItem("sitSetting"))
                              ?.whatsappSupport
                        }
                        target="_blank"
                      >
                        <span className="ribbon">◉ LIVE</span>
                        <picture className="gameCard-image">
                          <img
                            src={
                              process.env.PUBLIC_URL + "./mainimage/support.jpg"
                            }
                            alt=""
                          />
                        </picture>
                      </a>
                    ) : (
                      ""
                    )}

                    {/* <Link
                  className='gameCard-container'
                  // to={`/Homepage/ludoClassicRich`}
                  to={`#`}
                >
                  <span className='d-none blink text-danger d-block text-right game_status_live'>
                    ◉ COMING SOON
                  </span>
                  <picture className='gameCard-image'>
                    <img
                     
                      src={
                        process.env.PUBLIC_URL +
                        './mainimage/snake.jpg'
                      }
                      alt=''
                    />
                  </picture>
                </Link> */}
                  </>
                </div>
              </div>
            </section>

            {/* <div className='downloadButton'>
              <Downloadbutton />
            </div> */}
            <h2 class="title mb-3  text-uppercase">
              <span>Explore Our Services</span>
            </h2>
            <div className="skillbased">
              <img
                className="w-100"
                src={process.env.PUBLIC_URL + "./mainimage/Baner.jpg"}
                alt=""
              />
            </div>
          </div>
        </div>
      </div>
      <div className="rightContainer">
        <Rightcontainer />
      </div>
    </>
  );
}
